import { Modal } from '@mui/material'
import React from 'react'
import { XIcon } from '../../svgIcons/XIcon'

function Popup(props: {
    className?: string
    contentClassName?: string
    background?: string
    title?: string
    contentPadding?: string
    open: boolean
    children: JSX.Element
    onClose: () => void
    maxWidth?: number
}) {
    const { children, open = false, title, onClose, background = '#010620', contentPadding = '6', contentClassName = '', maxWidth = 528, className = '' } = props

    const handleClose = () => {
        onClose()
    }

    return (
        <Modal
            disableAutoFocus={true}
            disableEnforceFocus={true}
            // BackdropComponent={Backdrop}
            open={open}
            sx={{ border: 'initial', outline: 'none', ':focus': 'none', background: 'rgba(0, 0, 0, 0.7  )' }}
            onClose={handleClose}>
            <div
                className={`${className} p-3 w-full lg:w-auto flex justify-center`}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    // boxShadow: 40,
                    borderRadius: '16px'
                }}>
                <div
                    className={`${contentClassName} bg-[#010620] p-${contentPadding} border border-[1px] border-[#0C3F6D] rounded-lg max-w-[${
                        // className={`${contentClassName}  bg-[#010620] p-6 border border-[1px] border-[#0C3F6D]  w-full lg:w-[${maxWidth || 528}px] rounded-lg max-w-[${
                        maxWidth || 528
                    }px]`}
                    style={{ background: background }}>
                    {title ? (
                        <div className='flex justify-between items-center border-b-[1px] border-[#0C3F6D] pb-6 items-center'>
                            <span className='font-bold text-2xl text-white'>{title}</span>
                            <XIcon onClick={handleClose} className='cursor-pointer w-4 h-4' />
                        </div>
                    ) : null}
                    {children}
                </div>
            </div>
        </Modal>
    )
}

export default Popup
